define('lq/runtimeClone',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var prepare = function (parent) {
        _.forEach(parent.pool, function (drop) {
            if (drop.data.id && !drop.$element.hasClass('runtime-selectable'))
                drop.$element.addClass('runtime-selectable runtime-drop-' + drop.data.id);

            prepare(drop);
        });
    };

    var RuntimeClone = function (options) {
        this.options = options;
        this.onClicked = this.select.bind(this);
        this.$container = null;
    };

    RuntimeClone.prototype.create = function () {
        prepare(this.options.action);

        var $masterPageClone = this.options.action.$masterPage
            .clone()
            .addClass('runtime-clone');

        var $actionClone = this.options.action.$element
            .clone()
            .addClass('runtime-clone');
    
        var $selectionBar = $('<div />')
            .css('top', 0)
            .addClass('selection-bar');
            
        var $selectionBarContent = $('<div />')
            .addClass('selection-bar-content')
            .text('Select an element or')
            .appendTo($selectionBar);

        $('<span />')
            .text('cancel')
            .addClass('clickable btn')
            .on('click', this.cancel.bind(this))
            .appendTo($selectionBarContent);

        this.$container = $('<div />')
            .addClass('runtime-clone-container')
            .append($masterPageClone)
            .append($actionClone)
            .append($selectionBar)
            .appendTo($('#licquid-application'));

        $('#licquid-application').addClass('runtime-clone-body');

        $(document).on('click', this.onClicked);
    };

    RuntimeClone.prototype.cancel = function () {
        this.options.onCancel();
    };

    RuntimeClone.prototype.select = function (e) {
        var $closest = $(e.target).closest('.runtime-selectable');
        if ($closest.length === 0)
            return;

        var classes = $closest.attr('class').split(' ');
        var idClassName = _.find(classes, function (className) {
            return className.indexOf('runtime-drop-') === 0;
        });
        var morphId = idClassName.substring('runtime-drop-'.length);

        var $pool = $(e.target).closest('.licquid-drops-pool');
        var actionData = this.options.action.data;
        var rootMorphId = $pool.length > 0
            ? actionData.id
            : actionData.masterPageId;

        this.options.onSelect(rootMorphId, morphId);
    };
    
    RuntimeClone.prototype.destroy = function () {
        this.$container.remove();
        this.$container = null;

        $('body').removeClass('runtime-clone-body');
        $(document).off('click', this.onClicked);
    };

    return RuntimeClone;
});
